import { lazy, type ComponentType, type LazyExoticComponent } from "react"

export const lazily = <T extends {}, U extends keyof T>(
  loader: (x?: string) => Promise<T>
) =>
  new Proxy({} as unknown as T, {
    get: (_, componentName: string | symbol) => {
      if (typeof componentName === "string") {
        let componentPromise: Promise<
          LazyExoticComponent<ComponentType<any>>
        > | null = null

        const preload = () => {
          if (!componentPromise) {
            componentPromise = loader(componentName).then((x) => ({
              default: x[componentName as U] as any as ComponentType<any>,
            })) as any
          }
          return componentPromise
        }

        const LazyComp = lazy(() =>
          loader(componentName).then((x) => ({
            default: x[componentName as U] as any as ComponentType<any>,
          }))
        ) as unknown as any

        LazyComp.preload = preload

        return LazyComp
      }
    },
  })
